export { default } from "./LoadingProduct";